/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { PromptConfigurationsControllerFindOneQueryResponse, PromptConfigurationsControllerFindOnePathParams, PromptConfigurationsControllerFindOne401, PromptConfigurationsControllerFindOne403, PromptConfigurationsControllerFindOne404 } from "../../models/promptConfigurationsController/PromptConfigurationsControllerFindOne";

function getPromptConfigurationsControllerFindOneUrl(id: PromptConfigurationsControllerFindOnePathParams["id"]) {
  const res = { method: 'GET', url: `/api/v1/prompt-configurations/${id}` as const }  
  return res
}

/**
 * @summary Get a prompt configuration by ID
 * {@link /api/v1/prompt-configurations/:id}
 */
export async function promptConfigurationsControllerFindOne(id: PromptConfigurationsControllerFindOnePathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<PromptConfigurationsControllerFindOneQueryResponse, ResponseErrorConfig<PromptConfigurationsControllerFindOne401 | PromptConfigurationsControllerFindOne403 | PromptConfigurationsControllerFindOne404>, unknown>({ method : "GET", url : getPromptConfigurationsControllerFindOneUrl(id).url.toString(), ... requestConfig })  
  return res.data
}